// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./font/Satisfy/Satisfy-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("font/Josefin_Sans/JosefinSans-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./img/home-bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./img/home-bg-tab.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Satisfy";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: "JosefinSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___})
    format("truetype");
  font-weight: 400 800;
  font-style: normal;
}

:root {
  /* Colors (palette)*/
  --col-accent: #f5cb5c;
  --col-accent-shade: #feb80a;
  --col-pure-white: #ffffff;
  --col-white: #e8eddf;
  --col-light-grey: #cfdbd5;
  --col-dark-grey: #333533;
  --col-black: #242423;
  --col-pure-black: #000000;

  --accent-gradient: linear-gradient(
    var(--col-accent) 30%,
    var(--col-accent-shade)
  );

  /* Colors (background)*/
  --bg-col: var(--col-white);
  --bg-col-txt: var(--accent-gradient);
  --bg-col-txt-alt: var(--col-dark-grey);
  --bg-col-button: var(--col-accent);

  /* Colors (text/icons)*/
  --col-txt: var(--col-black);
  --col-txt-alt: var(--col-white);
  --col-p-home: var(--col-black);
  --col-h3-book-now: var(--col-pure-white);
  --col-h2-tab: var(--col-black);
  --col-h3: var(--col-black);
  --col-h3-alt: var(--col-white);
  --col-h4: var(--col-dark-grey);
  --col-h4-alt: var(--col-accent);

  /* Font family */
  --main-font: "JosefinSans", sans-serif;
  --main-font-alt: "Satisfy", serif;
  --title-font: var(--main-font-alt);
  --button-font: var(--main-font-alt);

  /* Font sizes */
  --txt-fontsize: max(18px, 0.6vw);
  --txt-lineheight: 1.2;
  --title-font-size: 2.5rem;
  --home-h2-fontsize: min(4vw, 2rem);
  --home-txt-fontsize: min(6vw, 3rem);
  --tab-h2-fontsize: 2.5rem;
  --tab-h3-fontsize: 2rem;
  --tab-h3-menu-fontsize: 2.8rem;
  --tab-h4-fontsize: 2rem;
  --tab-p-fontsize: 1rem;
  --tab-price-fontsize: 1.2rem;
  --button-font-size: 1.5rem;
  --book-now-font-size: 1rem;

  --logo-size: calc(2 * var(--title-font-size));

  /* Maximum width (including dashboard margin) */
  --max-width: min(1440px, 100%);

  /*Margins, gaps and paddings (+widths)*/
  --home-button-tb-margin: 10vh;
  --home-padding: calc(max(0.5em, 5vh)) 1em;
  --header-padding: 1rem;
  --header-gap: 1rem;
  --footer-padding: 3rem 2rem;
  --footer-gap: 2rem;
  --tab-header-padding: 1rem 1rem 2rem;
  --tab-section-padding: 3.5rem 2rem;
  --tab-section-gap: 2rem;
  --tab-div-inside-section-gap: 1rem 2rem;
  --tab-div-inside-section-with-subsections-gap: 2rem 2rem;
  --tab-div-inside-subsections-gap: 0.5rem 0.5rem;
  --tab-section-empty-space: 55vh;
  --tab-price-padding: 0.3em 0.5em;
  --nav-gap: 1.5em;
  --nav-btn-sel-scale: 1.2;
  --contact-hours-horizontal-gap: 3rem;
  --book-now-max-width: 40em;
  --book-now-input-div-gap: 1.5em 2em;
  --book-now-input-padding: 0.5em 1em;
  --button-padding: 0.2em 1.2em;

  /* Radius */
  --radius: 4rem;
  --sel-radius: 50% 50% 78% 22% / 30% 49% 51% 70%;
  --map-radius: 1rem;
  --book-now-input-radius: 1rem;
  --button-radius: calc(var(--book-now-max-width) / 2);

  /* Shadows */
  --col-p-home: var(--col-dark-grey);
  --text-shadow: 3px 3px 3px var(--col-light-grey);
  --box-shadow-large: 0px 0px 20px 3px var(--col-dark-grey);
  --box-shadow-small: 0px 0px 4px 2px var(--col-pure-black);
  --box-shadow-inset-top: 0px 15px 15px -15px var(--col-dark-grey) inset;
  --box-shadow-double: var(--box-shadow-small), var(--box-shadow-large);

  /* Animations on hover / active / ...*/
  /* --transition-time: 0.8s; */
}

html {
  background-color: var(--bg-col);
  color: var(--col-txt);
  font-family: var(--main-font), sans-serif;
  font-weight: 400;
  font-size: var(--txt-fontsize);
  line-height: var(--txt-lineheight);
}

*,
*:before,
*:after {
  font-family: inherit;
  font-size: inherit; /* 100% */
  line-height: inherit;
  color: inherit;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  vertical-align: baseline;
}

body {
  margin: 0 auto;

  /* if you want to allow scroll: */
  min-height: 100vh;
  height: 100%;

  width: 100%;
  /* or max-width -- this avoids horizontal scroll bars */

  touch-action: manipulation; /* disable double tap to zoom on some browsers*/

  display: flex;
  flex-direction: column;
  align-items: center;
}

body > * {
  width: 100%;
}

.screen-height {
  min-height: 100vh;
  min-height: 100dvh; /* if supported */

  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  display: flex;
  flex-direction: column;
}

.screen-height:has(.tab) {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

h1,
h2,
h3,
h4,
p {
  text-wrap: balance;
}

p {
  text-wrap: wrap;
  text-wrap: pretty; /* if supported */
}

ul {
  list-style: none;
}

a,
a:hover,
a:active,
a:visited {
  text-decoration: none;
}

/* Button style might be overwritten */
button.styled {
  background-color: var(--bg-col-button);
  border: none;
  font-family: var(--button-font);
  font-size: var(--button-font-size);
  font-weight: 800;
  border-radius: var(--button-radius);
  padding: var(--button-padding);
  box-shadow: var(--box-shadow-small);
  width: max-content;
  background: var(--accent-gradient);
}

button.styled:active {
  filter: brightness(0.7);
}

@media not all and (hover: none) {
  button.styled:hover {
    filter: brightness(0.7);
  }
}

/* LOGO */
.logo-and-name {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.logo-and-name .name {
  font-family: var(--title-font);
  font-size: var(--title-font-size);
}
.logo-and-name img {
  width: var(--logo-size);
}

/* HEADER */

.screen-height > header {
  width: 100%;
  max-width: var(--max-width);
  margin: 0 auto;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: var(--header-padding);
  gap: var(--header-gap);
}

.screen-height > header nav {
  display: flex;
  gap: var(--nav-gap);
}
.screen-height > header nav button {
  text-transform: uppercase;
  background-color: transparent;
  border: none;
  font-weight: 800;
}

.screen-height:has(.home) > header .logo-and-name {
  pointer-events: none;
}
.screen-height:has(.tab.about) > header nav button.about-btn,
.screen-height:has(.tab.menu) > header nav button.menu-btn,
.screen-height:has(.tab.contact) > header nav button.contact-btn {
  transform: scale(var(--nav-btn-sel-scale));
  pointer-events: none;
  background: var(--accent-gradient);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

/* tablet or larger, or landscape (vs portrait)*/
@media only screen and (min-width: 768px), (orientation: landscape) {
  .screen-height > header {
    flex-direction: row;
  }

  .logo-and-name {
    flex-direction: row;
  }
}

/* when hover is supported */
@media not all and (hover: none) {
  .logo-and-name:hover {
    text-shadow: 2px 2px 2px var(--col-accent);
    cursor: pointer;
  }

  .screen-height > header nav button:hover {
    cursor: pointer;
    background: var(--accent-gradient);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
  }
}

/* CONTENT */
#content {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
}

/* HOME PAGE */
#content.home {
  justify-content: space-evenly;
}

#content.home .home-txt {
  color: var(--col-p-home);
  font-size: var(--home-txt-fontsize);
  text-shadow: var(--text-shadow);
  padding: var(--home-padding);
  width: 100%;
  text-align: center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  box-shadow: var(--box-shadow-large);
}

#content.home .home-txt h2 {
  font-size: var(--home-h2-fontsize);
  text-transform: uppercase;
  text-shadow: none;
  background: var(--accent-gradient);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

#content.home .highlight {
  font-family: var(--main-font-alt);
}

#content.home button {
  margin: var(--home-button-tb-margin) auto;
}

/* TAB PAGES */

#content:has(.tab) {
  justify-content: flex-start;
}

#content.tab section:nth-child(2n) {
  --section-bg-col-txt: var(--bg-col-txt-alt);
  --section-col-h3: var(--col-h4-alt);
  --section-col-h4: var(--col-h4-alt);
  --section-col-txt: var(--col-txt-alt);
  --section-bg-col-alt: var(--bg-col-txt);
  --section-col-txt-alt: var(--col-txt);
}
#content.tab section:nth-child(2n + 1) {
  --section-bg-col-txt: var(--bg-col-txt);
  --section-col-h3: var(--col-h4);
  --section-col-h4: var(--col-h4);
  --section-col-txt: var(--col-txt);
  --section-bg-col-alt: var(--bg-col-txt-alt);
  --section-col-txt-alt: var(--col-txt-alt);
}
#content.tab section.has-subsections:nth-child(2n) {
  --section-col-h3: var(--col-h3-alt);
}
#content.tab section.has-subsections:nth-child(2n + 1) {
  --section-col-h3: var(--col-h3);
}

#content.tab header {
  padding: var(--tab-header-padding);
}
#content.tab h2 {
  font-size: var(--tab-h2-fontsize);
  text-transform: uppercase;
  color: var(--col-h2-tab);
  font-weight: 800;
}

#content.tab section {
  background-color: transparent;
  width: 100%;
}

#content.tab section .section-container {
  max-width: var(--max-width);
  margin: 0 auto;
}

#content.tab section.with-bg-image,
#content.tab section:not(.with-bg-image) .section-container {
  box-shadow: var(--box-shadow-double);
}

#content.tab section:not(.with-bg-image).img-fixed .img-side {
  box-shadow: var(--box-shadow-inset-top);
}

#content.tab section:not(.with-bg-image) .section-container,
#content.tab section:not(.with-bg-image) .txt-side {
  background: var(--section-bg-col-txt);
}

#content.tab section .txt-side,
#content.tab section .txt-side > div,
#content.tab section .txt-side > div > div {
  display: flex;
  flex-direction: column;
}

#content.tab section .txt-side {
  padding: var(--tab-section-padding);
  gap: var(--tab-section-gap);
}

#content.tab section .txt-side > div {
  gap: var(--tab-div-inside-section-gap);
}

#content.tab section.has-subsections .txt-side > div {
  gap: var(--tab-div-inside-section-with-subsections-gap);
}

#content.tab section .txt-side > div > div {
  gap: var(--tab-div-inside-subsections-gap);
}

#content.tab section h3 {
  font-family: var(--main-font-alt);
  font-size: var(--tab-h3-fontsize);
  color: var(--section-col-h3);
}
#content.tab section.has-subsections h3 {
  font-size: var(--tab-h3-menu-fontsize);
  font-variant: small-caps;
  font-family: var(--main-font);
  text-align: center;
}
#content.tab section h4 {
  font-family: var(--main-font-alt);
  font-size: var(--tab-h4-fontsize);
  color: var(--section-col-h4);
}
#content.tab section p {
  font-size: var(--tab-p-fontsize);
  color: var(--section-col-txt);
}

#content.tab section.with-bg-image,
#content.tab section .img-side {
  min-height: 100%;
  max-height: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

#content.tab section.with-bg-image.img-fixed,
#content.tab section.with-side-image.img-fixed .img-side {
  background-attachment: fixed;
}

#content.tab section.with-side-image .img-side {
  min-height: var(--tab-section-empty-space);
}

#content.tab section.with-side-image.img-alternate .section-container {
  display: grid;
  grid-template-areas:
    "img"
    "txt";
  grid-template-columns: 1fr;
  grid-template-rows: min-content min-content;
  --txt-side-width: 1fr; /* used in the next media query */
  --img-side-width: 1.2fr; /* used in the next media query */
}

@media only screen and (min-width: 768px), (orientation: landscape) {
  #content.tab section.with-side-image.img-alternate .section-container {
    grid-template-rows: max-content;
  }

  #content.tab
    section.with-side-image.img-alternate.img-first:nth-child(2n + 1)
    .section-container,
  #content.tab
    section.with-side-image.img-alternate:nth-child(2n)
    .section-container {
    grid-template-areas: "txt img";
    grid-template-columns: var(--txt-side-width) var(--img-side-width);
  }

  #content.tab
    section.with-side-image.img-alternate:nth-child(2n + 1)
    .section-container,
  #content.tab
    section.with-side-image.img-alternate.img-first:nth-child(2n)
    .section-container {
    grid-template-areas: "img txt";
    grid-template-columns: var(--img-side-width) var(--txt-side-width);
  }

  #content.tab section.with-side-image:not(.img-fixed) .img-side {
    min-height: auto;
  }
}

#content.tab section.with-side-image.img-alternate .txt-side {
  grid-area: txt;
}
#content.tab section.with-side-image.img-alternate .img-side {
  grid-area: img;
}

/* rules specific to menu tab */

#content.tab.menu section .dish {
  display: grid;
  justify-content: space-between;
  align-items: center;
  grid-template-areas:
    "h4 price"
    "p p";
  grid-template-columns: 1fr max-content;
}
#content.tab.menu .dish h4 {
  grid-area: h4;
}
#content.tab.menu .dish .price {
  border-radius: var(--sel-radius);
  padding: var(--tab-price-padding);
  font-size: var(--tab-price-fontsize);
  background: var(--section-bg-col-alt);
  color: var(--section-col-txt-alt);
  grid-area: price;
}
#content.tab.menu .dish p {
  grid-area: p;
  justify-self: left;
}

/* rules specific to contact tab */

#content.tab.contact section.with-side-image.img-alternate .section-container {
  --txt-side-width: minmax(max-content, 1fr);
}

#content.tab.contact section.with-side-image.img-alternate .txt-side {
  width: 100%;
}
#content.tab.contact section.with-side-image.img-alternate .txt-side > * {
  max-width: max-content;
  margin: 0 auto;
}

#content.tab.contact div.days-and-hours {
  display: grid;
  justify-content: space-between;
  grid-template-columns: max-content max-content;
}

#content.tab.contact .txt-side .days {
  color: var(--section-col-h4);
  font-variant: small-caps;
  text-transform: lowercase;
  font-weight: bold;
}

#content.tab.contact .txt-side .hours {
  display: flex;
  flex-direction: column;
  gap: 0px var(--contact-hours-horizontal-gap);
}

#content.tab.contact .txt-side .hour {
  width: max-content;
}

@media only screen and (min-width: 1024px) {
  #content.tab.contact .txt-side .hours {
    flex-direction: row;
  }
}

.contact-info {
  display: flex;
  flex-direction: column;
  gap: 1em;
}

.contact-info > .contact-list > * {
  display: grid;
  grid-template-columns: max-content 1fr;
  text-wrap: balance;
  gap: 0.5em;
}

/* Purposely exclude .address from here to better centering .contact-info */
.contact-info .phone,
.contact-info .email {
  width: max-content;
}

.contact-info > .contact-social {
  display: flex !important;
  flex-direction: row !important;
  justify-content: center;
  gap: 1em !important;
  color: var(--col-txt);
}

@media not all and (hover: none) {
  .contact-info > .contact-social a:hover {
    color: var(--col-accent);
    cursor: pointer;
  }
}

svg.svg-inline--fa {
  vertical-align: top;
  color: var(--section-col-h3);
}

/* See https://blog.duda.co/responsive-google-maps-for-your-website */
#content.tab section .txt-side > .location-map {
  overflow: hidden;
  border-radius: var(--map-radius);
  display: initial !important;
  padding-bottom: 56.25%;
  position: relative;
  height: 0;
  flex: 1;
  min-width: 100%;
}

#content.tab section .txt-side > .location-map iframe {
  display: initial !important;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  position: absolute;
}

/* BOOK NOW tab */

#content.tab.book-now h2 {
  display: none;
}

#content.tab.book-now h3 {
  color: var(--col-h3-book-now);
  text-align: center;
}

#content.tab.book-now section .section-container {
  backdrop-filter: blur(2px) brightness(70%);
  max-width: 100%;
}

#content.tab.book-now button {
  grid-area: button;
  justify-self: center;
}

#content.tab.book-now form {
  display: grid;
  grid-template-areas:
    "name"
    "guests"
    "date"
    "hour"
    "email"
    "phone"
    "note"
    "."
    "button";
  grid-template-columns: 1fr;
  grid-template-columns: auto;
  gap: var(--book-now-input-div-gap);
  max-width: var(--book-now-max-width);
  width: 100%;
  margin: 0 auto;
}

@media only screen and (min-width: 768px), (orientation: landscape) {
  #content.tab.book-now form {
    grid-template-areas:
      "name name name name"
      "date date hour guests"
      "phone phone email email"
      "note note note note"
      ". . . ."
      ". button button .";
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
}

#content.tab.book-now form .name-input-div {
  grid-area: name;
}
#content.tab.book-now form .guests-input-div {
  grid-area: guests;
}
#content.tab.book-now form .date-input-div {
  grid-area: date;
}
#content.tab.book-now form .hour-input-div {
  grid-area: hour;
}
#content.tab.book-now form .phone-input-div {
  grid-area: phone;
}
#content.tab.book-now form .email-input-div {
  grid-area: email;
}
#content.tab.book-now form .note-input-div {
  grid-area: note;
}

#content.tab.book-now form > div {
  display: flex;
  flex-direction: column;
}

#content.tab.book-now form input,
#content.tab.book-now form textarea {
  border-radius: var(--book-now-input-radius);
  border: none;
  outline: none;
}

#content.tab.book-now form label,
#content.tab.book-now form input,
#content.tab.book-now form textarea {
  padding: var(--book-now-input-padding);
  font-size: var(--book-now-font-size);
}

#content.tab.book-now form label {
  padding-top: 0;
  color: var(--col-txt-alt);
}

#content.tab.book-now form label:has(+ input:optional)::after,
#content.tab.book-now form label:has(+ textarea:optional)::after {
  content: " (optional)";
  font-style: italic;
  color: var(--col-light-grey);
}

/* FOOTER */
:root {
  --footer-days-and-hours-padding: 1rem;
}

footer.main-footer {
  width: 100%;
  max-width: var(--max-width);
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  padding: var(--footer-padding);
  gap: var(--footer-padding);
}

footer.main-footer .footer-content {
  display: grid;
  grid-template-areas:
    "logo"
    "info"
    "hours";
  grid-template-columns: min-content;
  justify-content: center;
  justify-items: center;
  gap: var(--footer-gap);
}

footer.main-footer .logo-and-name {
  grid-area: logo;
  flex-direction: column;
}
footer.main-footer .contact-info {
  grid-area: info;
  align-self: center;
}

footer.main-footer .days-and-hours {
  grid-area: hours;
  display: grid;
  grid-template-columns: max-content;
  border-top: 1px solid var(--col-txt);
  justify-content: center;
  justify-items: center;
  padding: var(--footer-days-and-hours-padding);
  padding-bottom: 0;
}
footer.main-footer .days-and-hours .days {
  font-weight: bold;
}
footer.main-footer .days-and-hours .days:not(:first-child) {
  margin-top: var(--footer-days-and-hours-padding);
}
footer.main-footer .days-and-hours .hours {
  display: flex;
}

footer.main-footer .days-and-hours .hour:not(:last-child):after {
  content: ",\\00a0";
}

footer.main-footer .img-credit {
  grid-area: "img-credit";
  text-align: justify;
  text-justify: inter-word;
  text-wrap: pretty;
}

footer.main-footer .img-credit a {
  font-weight: bold;
}

@media not all and (hover: none) {
  footer.main-footer .img-credit a:hover {
    text-shadow: 2px 2px 2px var(--col-accent);
    cursor: pointer;
  }
}

@media only screen and (min-width: 768px), (orientation: landscape) {
  footer.main-footer .footer-content {
    grid-template-areas:
      "logo info"
      "hours hours";
    grid-template-columns: max-content max-content;
  }

  footer.main-footer .days-and-hours {
    grid-template-columns: max-content max-content;
    justify-items: start;
    gap: 0 var(--footer-days-and-hours-padding);
  }

  footer.main-footer .days-and-hours .days:not(:first-child) {
    margin-top: 0;
  }
}

@media only screen and (min-width: 1024px) {
  footer.main-footer .footer-content {
    grid-template-areas: "logo info hours";
    grid-template-columns: max-content max-content max-content;
  }

  footer.main-footer .days-and-hours {
    align-self: center;
    border: none;
    border-left: 1px solid var(--col-txt);
    padding: var(--footer-days-and-hours-padding);
    padding-right: 0;
  }

  footer.main-footer .days-and-hours .days:not(:first-child) {
    margin-top: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,+DAAiE;EACjE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B;sBACoB;EACpB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,2BAA2B;EAC3B,yBAAyB;EACzB,oBAAoB;EACpB,yBAAyB;EACzB,wBAAwB;EACxB,oBAAoB;EACpB,yBAAyB;;EAEzB;;;GAGC;;EAED,uBAAuB;EACvB,0BAA0B;EAC1B,oCAAoC;EACpC,sCAAsC;EACtC,kCAAkC;;EAElC,uBAAuB;EACvB,2BAA2B;EAC3B,+BAA+B;EAC/B,8BAA8B;EAC9B,wCAAwC;EACxC,8BAA8B;EAC9B,0BAA0B;EAC1B,8BAA8B;EAC9B,8BAA8B;EAC9B,+BAA+B;;EAE/B,gBAAgB;EAChB,sCAAsC;EACtC,iCAAiC;EACjC,kCAAkC;EAClC,mCAAmC;;EAEnC,eAAe;EACf,gCAAgC;EAChC,qBAAqB;EACrB,yBAAyB;EACzB,kCAAkC;EAClC,mCAAmC;EACnC,yBAAyB;EACzB,uBAAuB;EACvB,8BAA8B;EAC9B,uBAAuB;EACvB,sBAAsB;EACtB,4BAA4B;EAC5B,0BAA0B;EAC1B,0BAA0B;;EAE1B,6CAA6C;;EAE7C,+CAA+C;EAC/C,8BAA8B;;EAE9B,uCAAuC;EACvC,6BAA6B;EAC7B,yCAAyC;EACzC,sBAAsB;EACtB,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,oCAAoC;EACpC,kCAAkC;EAClC,uBAAuB;EACvB,uCAAuC;EACvC,wDAAwD;EACxD,+CAA+C;EAC/C,+BAA+B;EAC/B,gCAAgC;EAChC,gBAAgB;EAChB,wBAAwB;EACxB,oCAAoC;EACpC,0BAA0B;EAC1B,mCAAmC;EACnC,mCAAmC;EACnC,6BAA6B;;EAE7B,WAAW;EACX,cAAc;EACd,+CAA+C;EAC/C,kBAAkB;EAClB,6BAA6B;EAC7B,oDAAoD;;EAEpD,YAAY;EACZ,kCAAkC;EAClC,gDAAgD;EAChD,yDAAyD;EACzD,yDAAyD;EACzD,sEAAsE;EACtE,qEAAqE;;EAErE,sCAAsC;EACtC,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,yCAAyC;EACzC,gBAAgB;EAChB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;;;EAGE,oBAAoB;EACpB,kBAAkB,EAAE,SAAS;EAC7B,oBAAoB;EACpB,cAAc;EACd,sBAAsB;EACtB,UAAU;EACV,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,cAAc;;EAEd,iCAAiC;EACjC,iBAAiB;EACjB,YAAY;;EAEZ,WAAW;EACX,uDAAuD;;EAEvD,0BAA0B,EAAE,+CAA+C;;EAE3E,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB,EAAE,iBAAiB;;EAErC,yDAA0C;EAC1C,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yDAA8C;AAChD;;AAEA;;;;;EAKE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB,EAAE,iBAAiB;AACtC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA,sCAAsC;AACtC;EACE,sCAAsC;EACtC,YAAY;EACZ,+BAA+B;EAC/B,kCAAkC;EAClC,gBAAgB;EAChB,mCAAmC;EACnC,8BAA8B;EAC9B,mCAAmC;EACnC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;AACA;EACE,uBAAuB;AACzB;;AAEA,WAAW;;AAEX;EACE,WAAW;EACX,2BAA2B;EAC3B,cAAc;;EAEd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;EAC9B,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;AACA;;;EAGE,0CAA0C;EAC1C,oBAAoB;EACpB,kCAAkC;EAClC,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,gDAAgD;AAChD;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,4BAA4B;AAC5B;EACE;IACE,0CAA0C;IAC1C,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kCAAkC;IAClC,6BAA6B;IAC7B,qBAAqB;IACrB,kBAAkB;EACpB;AACF;;AAEA,YAAY;AACZ;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,OAAO;AACT;;AAEA,cAAc;AACd;EACE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,mCAAmC;EACnC,+BAA+B;EAC/B,4BAA4B;EAC5B,WAAW;EACX,kBAAkB;EAClB,yDAA8C;EAC9C,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,iBAAiB;EACjB,kCAAkC;EAClC,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,cAAc;;AAEd;EACE,2BAA2B;AAC7B;;AAEA;EACE,2CAA2C;EAC3C,mCAAmC;EACnC,mCAAmC;EACnC,qCAAqC;EACrC,uCAAuC;EACvC,qCAAqC;AACvC;AACA;EACE,uCAAuC;EACvC,+BAA+B;EAC/B,+BAA+B;EAC/B,iCAAiC;EACjC,2CAA2C;EAC3C,yCAAyC;AAC3C;AACA;EACE,mCAAmC;AACrC;AACA;EACE,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;AACpC;AACA;EACE,iCAAiC;EACjC,yBAAyB;EACzB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;;;EAGE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;EACjC,4BAA4B;AAC9B;AACA;EACE,sCAAsC;EACtC,wBAAwB;EACxB,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,iCAAiC;EACjC,iCAAiC;EACjC,4BAA4B;AAC9B;AACA;EACE,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb;;SAEO;EACP,0BAA0B;EAC1B,2CAA2C;EAC3C,qBAAqB,EAAE,iCAAiC;EACxD,uBAAuB,EAAE,iCAAiC;AAC5D;;AAEA;EACE;IACE,+BAA+B;EACjC;;EAEA;;;;;;IAME,8BAA8B;IAC9B,kEAAkE;EACpE;;EAEA;;;;;;IAME,8BAA8B;IAC9B,kEAAkE;EACpE;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA,+BAA+B;;AAE/B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB;;SAEO;EACP,sCAAsC;AACxC;AACA;EACE,aAAa;AACf;AACA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,oCAAoC;EACpC,qCAAqC;EACrC,iCAAiC;EACjC,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA,kCAAkC;;AAElC;EACE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,8CAA8C;AAChD;;AAEA;EACE,4BAA4B;EAC5B,wBAAwB;EACxB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,kBAAkB;EAClB,UAAU;AACZ;;AAEA,2EAA2E;AAC3E;;EAEE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE;IACE,wBAAwB;IACxB,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA,qEAAqE;AACrE;EACE,gBAAgB;EAChB,gCAAgC;EAChC,2BAA2B;EAC3B,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,OAAO;EACP,MAAM;EACN,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA,iBAAiB;;AAEjB;EACE,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;EAC1C,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb;;;;;;;;;YASU;EACV,0BAA0B;EAC1B,2BAA2B;EAC3B,kCAAkC;EAClC,oCAAoC;EACpC,WAAW;EACX,cAAc;AAChB;;AAEA;EACE;IACE;;;;;;yBAMqB;IACrB,sCAAsC;EACxC;AACF;;AAEA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,2CAA2C;EAC3C,YAAY;EACZ,aAAa;AACf;;AAEA;;;EAGE,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,sBAAsB;EACtB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,WAAW;AACX;EACE,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb;;;WAGS;EACT,kCAAkC;EAClC,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kCAAkC;EAClC,oCAAoC;EACpC,uBAAuB;EACvB,qBAAqB;EACrB,6CAA6C;EAC7C,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gDAAgD;AAClD;AACA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,0CAA0C;IAC1C,eAAe;EACjB;AACF;;AAEA;EACE;IACE;;mBAEe;IACf,8CAA8C;EAChD;;EAEA;IACE,8CAA8C;IAC9C,oBAAoB;IACpB,2CAA2C;EAC7C;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,sCAAsC;IACtC,0DAA0D;EAC5D;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,qCAAqC;IACrC,6CAA6C;IAC7C,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["@font-face {\r\n  font-family: \"Satisfy\";\r\n  src: url(\"./font/Satisfy/Satisfy-Regular.ttf\") format(\"truetype\");\r\n  font-weight: 400;\r\n  font-style: normal;\r\n}\r\n@font-face {\r\n  font-family: \"JosefinSans\";\r\n  src: url(\"font/Josefin_Sans/JosefinSans-VariableFont_wght.ttf\")\r\n    format(\"truetype\");\r\n  font-weight: 400 800;\r\n  font-style: normal;\r\n}\r\n\r\n:root {\r\n  /* Colors (palette)*/\r\n  --col-accent: #f5cb5c;\r\n  --col-accent-shade: #feb80a;\r\n  --col-pure-white: #ffffff;\r\n  --col-white: #e8eddf;\r\n  --col-light-grey: #cfdbd5;\r\n  --col-dark-grey: #333533;\r\n  --col-black: #242423;\r\n  --col-pure-black: #000000;\r\n\r\n  --accent-gradient: linear-gradient(\r\n    var(--col-accent) 30%,\r\n    var(--col-accent-shade)\r\n  );\r\n\r\n  /* Colors (background)*/\r\n  --bg-col: var(--col-white);\r\n  --bg-col-txt: var(--accent-gradient);\r\n  --bg-col-txt-alt: var(--col-dark-grey);\r\n  --bg-col-button: var(--col-accent);\r\n\r\n  /* Colors (text/icons)*/\r\n  --col-txt: var(--col-black);\r\n  --col-txt-alt: var(--col-white);\r\n  --col-p-home: var(--col-black);\r\n  --col-h3-book-now: var(--col-pure-white);\r\n  --col-h2-tab: var(--col-black);\r\n  --col-h3: var(--col-black);\r\n  --col-h3-alt: var(--col-white);\r\n  --col-h4: var(--col-dark-grey);\r\n  --col-h4-alt: var(--col-accent);\r\n\r\n  /* Font family */\r\n  --main-font: \"JosefinSans\", sans-serif;\r\n  --main-font-alt: \"Satisfy\", serif;\r\n  --title-font: var(--main-font-alt);\r\n  --button-font: var(--main-font-alt);\r\n\r\n  /* Font sizes */\r\n  --txt-fontsize: max(18px, 0.6vw);\r\n  --txt-lineheight: 1.2;\r\n  --title-font-size: 2.5rem;\r\n  --home-h2-fontsize: min(4vw, 2rem);\r\n  --home-txt-fontsize: min(6vw, 3rem);\r\n  --tab-h2-fontsize: 2.5rem;\r\n  --tab-h3-fontsize: 2rem;\r\n  --tab-h3-menu-fontsize: 2.8rem;\r\n  --tab-h4-fontsize: 2rem;\r\n  --tab-p-fontsize: 1rem;\r\n  --tab-price-fontsize: 1.2rem;\r\n  --button-font-size: 1.5rem;\r\n  --book-now-font-size: 1rem;\r\n\r\n  --logo-size: calc(2 * var(--title-font-size));\r\n\r\n  /* Maximum width (including dashboard margin) */\r\n  --max-width: min(1440px, 100%);\r\n\r\n  /*Margins, gaps and paddings (+widths)*/\r\n  --home-button-tb-margin: 10vh;\r\n  --home-padding: calc(max(0.5em, 5vh)) 1em;\r\n  --header-padding: 1rem;\r\n  --header-gap: 1rem;\r\n  --footer-padding: 3rem 2rem;\r\n  --footer-gap: 2rem;\r\n  --tab-header-padding: 1rem 1rem 2rem;\r\n  --tab-section-padding: 3.5rem 2rem;\r\n  --tab-section-gap: 2rem;\r\n  --tab-div-inside-section-gap: 1rem 2rem;\r\n  --tab-div-inside-section-with-subsections-gap: 2rem 2rem;\r\n  --tab-div-inside-subsections-gap: 0.5rem 0.5rem;\r\n  --tab-section-empty-space: 55vh;\r\n  --tab-price-padding: 0.3em 0.5em;\r\n  --nav-gap: 1.5em;\r\n  --nav-btn-sel-scale: 1.2;\r\n  --contact-hours-horizontal-gap: 3rem;\r\n  --book-now-max-width: 40em;\r\n  --book-now-input-div-gap: 1.5em 2em;\r\n  --book-now-input-padding: 0.5em 1em;\r\n  --button-padding: 0.2em 1.2em;\r\n\r\n  /* Radius */\r\n  --radius: 4rem;\r\n  --sel-radius: 50% 50% 78% 22% / 30% 49% 51% 70%;\r\n  --map-radius: 1rem;\r\n  --book-now-input-radius: 1rem;\r\n  --button-radius: calc(var(--book-now-max-width) / 2);\r\n\r\n  /* Shadows */\r\n  --col-p-home: var(--col-dark-grey);\r\n  --text-shadow: 3px 3px 3px var(--col-light-grey);\r\n  --box-shadow-large: 0px 0px 20px 3px var(--col-dark-grey);\r\n  --box-shadow-small: 0px 0px 4px 2px var(--col-pure-black);\r\n  --box-shadow-inset-top: 0px 15px 15px -15px var(--col-dark-grey) inset;\r\n  --box-shadow-double: var(--box-shadow-small), var(--box-shadow-large);\r\n\r\n  /* Animations on hover / active / ...*/\r\n  /* --transition-time: 0.8s; */\r\n}\r\n\r\nhtml {\r\n  background-color: var(--bg-col);\r\n  color: var(--col-txt);\r\n  font-family: var(--main-font), sans-serif;\r\n  font-weight: 400;\r\n  font-size: var(--txt-fontsize);\r\n  line-height: var(--txt-lineheight);\r\n}\r\n\r\n*,\r\n*:before,\r\n*:after {\r\n  font-family: inherit;\r\n  font-size: inherit; /* 100% */\r\n  line-height: inherit;\r\n  color: inherit;\r\n  box-sizing: border-box;\r\n  padding: 0;\r\n  margin: 0;\r\n  vertical-align: baseline;\r\n}\r\n\r\nbody {\r\n  margin: 0 auto;\r\n\r\n  /* if you want to allow scroll: */\r\n  min-height: 100vh;\r\n  height: 100%;\r\n\r\n  width: 100%;\r\n  /* or max-width -- this avoids horizontal scroll bars */\r\n\r\n  touch-action: manipulation; /* disable double tap to zoom on some browsers*/\r\n\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n\r\nbody > * {\r\n  width: 100%;\r\n}\r\n\r\n.screen-height {\r\n  min-height: 100vh;\r\n  min-height: 100dvh; /* if supported */\r\n\r\n  background-image: url(\"./img/home-bg.jpg\");\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n  background-position: center;\r\n  background-attachment: fixed;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.screen-height:has(.tab) {\r\n  background-image: url(\"./img/home-bg-tab.jpg\");\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\np {\r\n  text-wrap: balance;\r\n}\r\n\r\np {\r\n  text-wrap: wrap;\r\n  text-wrap: pretty; /* if supported */\r\n}\r\n\r\nul {\r\n  list-style: none;\r\n}\r\n\r\na,\r\na:hover,\r\na:active,\r\na:visited {\r\n  text-decoration: none;\r\n}\r\n\r\n/* Button style might be overwritten */\r\nbutton.styled {\r\n  background-color: var(--bg-col-button);\r\n  border: none;\r\n  font-family: var(--button-font);\r\n  font-size: var(--button-font-size);\r\n  font-weight: 800;\r\n  border-radius: var(--button-radius);\r\n  padding: var(--button-padding);\r\n  box-shadow: var(--box-shadow-small);\r\n  width: max-content;\r\n  background: var(--accent-gradient);\r\n}\r\n\r\nbutton.styled:active {\r\n  filter: brightness(0.7);\r\n}\r\n\r\n@media not all and (hover: none) {\r\n  button.styled:hover {\r\n    filter: brightness(0.7);\r\n  }\r\n}\r\n\r\n/* LOGO */\r\n.logo-and-name {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n\r\n.logo-and-name .name {\r\n  font-family: var(--title-font);\r\n  font-size: var(--title-font-size);\r\n}\r\n.logo-and-name img {\r\n  width: var(--logo-size);\r\n}\r\n\r\n/* HEADER */\r\n\r\n.screen-height > header {\r\n  width: 100%;\r\n  max-width: var(--max-width);\r\n  margin: 0 auto;\r\n\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: var(--header-padding);\r\n  gap: var(--header-gap);\r\n}\r\n\r\n.screen-height > header nav {\r\n  display: flex;\r\n  gap: var(--nav-gap);\r\n}\r\n.screen-height > header nav button {\r\n  text-transform: uppercase;\r\n  background-color: transparent;\r\n  border: none;\r\n  font-weight: 800;\r\n}\r\n\r\n.screen-height:has(.home) > header .logo-and-name {\r\n  pointer-events: none;\r\n}\r\n.screen-height:has(.tab.about) > header nav button.about-btn,\r\n.screen-height:has(.tab.menu) > header nav button.menu-btn,\r\n.screen-height:has(.tab.contact) > header nav button.contact-btn {\r\n  transform: scale(var(--nav-btn-sel-scale));\r\n  pointer-events: none;\r\n  background: var(--accent-gradient);\r\n  -webkit-background-clip: text;\r\n  background-clip: text;\r\n  color: transparent;\r\n}\r\n\r\n/* tablet or larger, or landscape (vs portrait)*/\r\n@media only screen and (min-width: 768px), (orientation: landscape) {\r\n  .screen-height > header {\r\n    flex-direction: row;\r\n  }\r\n\r\n  .logo-and-name {\r\n    flex-direction: row;\r\n  }\r\n}\r\n\r\n/* when hover is supported */\r\n@media not all and (hover: none) {\r\n  .logo-and-name:hover {\r\n    text-shadow: 2px 2px 2px var(--col-accent);\r\n    cursor: pointer;\r\n  }\r\n\r\n  .screen-height > header nav button:hover {\r\n    cursor: pointer;\r\n    background: var(--accent-gradient);\r\n    -webkit-background-clip: text;\r\n    background-clip: text;\r\n    color: transparent;\r\n  }\r\n}\r\n\r\n/* CONTENT */\r\n#content {\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex: 1;\r\n}\r\n\r\n/* HOME PAGE */\r\n#content.home {\r\n  justify-content: space-evenly;\r\n}\r\n\r\n#content.home .home-txt {\r\n  color: var(--col-p-home);\r\n  font-size: var(--home-txt-fontsize);\r\n  text-shadow: var(--text-shadow);\r\n  padding: var(--home-padding);\r\n  width: 100%;\r\n  text-align: center;\r\n  background-image: url(\"./img/home-bg-tab.jpg\");\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n  background-position: center;\r\n  background-attachment: fixed;\r\n  box-shadow: var(--box-shadow-large);\r\n}\r\n\r\n#content.home .home-txt h2 {\r\n  font-size: var(--home-h2-fontsize);\r\n  text-transform: uppercase;\r\n  text-shadow: none;\r\n  background: var(--accent-gradient);\r\n  -webkit-background-clip: text;\r\n  background-clip: text;\r\n  color: transparent;\r\n}\r\n\r\n#content.home .highlight {\r\n  font-family: var(--main-font-alt);\r\n}\r\n\r\n#content.home button {\r\n  margin: var(--home-button-tb-margin) auto;\r\n}\r\n\r\n/* TAB PAGES */\r\n\r\n#content:has(.tab) {\r\n  justify-content: flex-start;\r\n}\r\n\r\n#content.tab section:nth-child(2n) {\r\n  --section-bg-col-txt: var(--bg-col-txt-alt);\r\n  --section-col-h3: var(--col-h4-alt);\r\n  --section-col-h4: var(--col-h4-alt);\r\n  --section-col-txt: var(--col-txt-alt);\r\n  --section-bg-col-alt: var(--bg-col-txt);\r\n  --section-col-txt-alt: var(--col-txt);\r\n}\r\n#content.tab section:nth-child(2n + 1) {\r\n  --section-bg-col-txt: var(--bg-col-txt);\r\n  --section-col-h3: var(--col-h4);\r\n  --section-col-h4: var(--col-h4);\r\n  --section-col-txt: var(--col-txt);\r\n  --section-bg-col-alt: var(--bg-col-txt-alt);\r\n  --section-col-txt-alt: var(--col-txt-alt);\r\n}\r\n#content.tab section.has-subsections:nth-child(2n) {\r\n  --section-col-h3: var(--col-h3-alt);\r\n}\r\n#content.tab section.has-subsections:nth-child(2n + 1) {\r\n  --section-col-h3: var(--col-h3);\r\n}\r\n\r\n#content.tab header {\r\n  padding: var(--tab-header-padding);\r\n}\r\n#content.tab h2 {\r\n  font-size: var(--tab-h2-fontsize);\r\n  text-transform: uppercase;\r\n  color: var(--col-h2-tab);\r\n  font-weight: 800;\r\n}\r\n\r\n#content.tab section {\r\n  background-color: transparent;\r\n  width: 100%;\r\n}\r\n\r\n#content.tab section .section-container {\r\n  max-width: var(--max-width);\r\n  margin: 0 auto;\r\n}\r\n\r\n#content.tab section.with-bg-image,\r\n#content.tab section:not(.with-bg-image) .section-container {\r\n  box-shadow: var(--box-shadow-double);\r\n}\r\n\r\n#content.tab section:not(.with-bg-image).img-fixed .img-side {\r\n  box-shadow: var(--box-shadow-inset-top);\r\n}\r\n\r\n#content.tab section:not(.with-bg-image) .section-container,\r\n#content.tab section:not(.with-bg-image) .txt-side {\r\n  background: var(--section-bg-col-txt);\r\n}\r\n\r\n#content.tab section .txt-side,\r\n#content.tab section .txt-side > div,\r\n#content.tab section .txt-side > div > div {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n#content.tab section .txt-side {\r\n  padding: var(--tab-section-padding);\r\n  gap: var(--tab-section-gap);\r\n}\r\n\r\n#content.tab section .txt-side > div {\r\n  gap: var(--tab-div-inside-section-gap);\r\n}\r\n\r\n#content.tab section.has-subsections .txt-side > div {\r\n  gap: var(--tab-div-inside-section-with-subsections-gap);\r\n}\r\n\r\n#content.tab section .txt-side > div > div {\r\n  gap: var(--tab-div-inside-subsections-gap);\r\n}\r\n\r\n#content.tab section h3 {\r\n  font-family: var(--main-font-alt);\r\n  font-size: var(--tab-h3-fontsize);\r\n  color: var(--section-col-h3);\r\n}\r\n#content.tab section.has-subsections h3 {\r\n  font-size: var(--tab-h3-menu-fontsize);\r\n  font-variant: small-caps;\r\n  font-family: var(--main-font);\r\n  text-align: center;\r\n}\r\n#content.tab section h4 {\r\n  font-family: var(--main-font-alt);\r\n  font-size: var(--tab-h4-fontsize);\r\n  color: var(--section-col-h4);\r\n}\r\n#content.tab section p {\r\n  font-size: var(--tab-p-fontsize);\r\n  color: var(--section-col-txt);\r\n}\r\n\r\n#content.tab section.with-bg-image,\r\n#content.tab section .img-side {\r\n  min-height: 100%;\r\n  max-height: 100%;\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n  background-position: center;\r\n}\r\n\r\n#content.tab section.with-bg-image.img-fixed,\r\n#content.tab section.with-side-image.img-fixed .img-side {\r\n  background-attachment: fixed;\r\n}\r\n\r\n#content.tab section.with-side-image .img-side {\r\n  min-height: var(--tab-section-empty-space);\r\n}\r\n\r\n#content.tab section.with-side-image.img-alternate .section-container {\r\n  display: grid;\r\n  grid-template-areas:\r\n    \"img\"\r\n    \"txt\";\r\n  grid-template-columns: 1fr;\r\n  grid-template-rows: min-content min-content;\r\n  --txt-side-width: 1fr; /* used in the next media query */\r\n  --img-side-width: 1.2fr; /* used in the next media query */\r\n}\r\n\r\n@media only screen and (min-width: 768px), (orientation: landscape) {\r\n  #content.tab section.with-side-image.img-alternate .section-container {\r\n    grid-template-rows: max-content;\r\n  }\r\n\r\n  #content.tab\r\n    section.with-side-image.img-alternate.img-first:nth-child(2n + 1)\r\n    .section-container,\r\n  #content.tab\r\n    section.with-side-image.img-alternate:nth-child(2n)\r\n    .section-container {\r\n    grid-template-areas: \"txt img\";\r\n    grid-template-columns: var(--txt-side-width) var(--img-side-width);\r\n  }\r\n\r\n  #content.tab\r\n    section.with-side-image.img-alternate:nth-child(2n + 1)\r\n    .section-container,\r\n  #content.tab\r\n    section.with-side-image.img-alternate.img-first:nth-child(2n)\r\n    .section-container {\r\n    grid-template-areas: \"img txt\";\r\n    grid-template-columns: var(--img-side-width) var(--txt-side-width);\r\n  }\r\n\r\n  #content.tab section.with-side-image:not(.img-fixed) .img-side {\r\n    min-height: auto;\r\n  }\r\n}\r\n\r\n#content.tab section.with-side-image.img-alternate .txt-side {\r\n  grid-area: txt;\r\n}\r\n#content.tab section.with-side-image.img-alternate .img-side {\r\n  grid-area: img;\r\n}\r\n\r\n/* rules specific to menu tab */\r\n\r\n#content.tab.menu section .dish {\r\n  display: grid;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  grid-template-areas:\r\n    \"h4 price\"\r\n    \"p p\";\r\n  grid-template-columns: 1fr max-content;\r\n}\r\n#content.tab.menu .dish h4 {\r\n  grid-area: h4;\r\n}\r\n#content.tab.menu .dish .price {\r\n  border-radius: var(--sel-radius);\r\n  padding: var(--tab-price-padding);\r\n  font-size: var(--tab-price-fontsize);\r\n  background: var(--section-bg-col-alt);\r\n  color: var(--section-col-txt-alt);\r\n  grid-area: price;\r\n}\r\n#content.tab.menu .dish p {\r\n  grid-area: p;\r\n  justify-self: left;\r\n}\r\n\r\n/* rules specific to contact tab */\r\n\r\n#content.tab.contact section.with-side-image.img-alternate .section-container {\r\n  --txt-side-width: minmax(max-content, 1fr);\r\n}\r\n\r\n#content.tab.contact section.with-side-image.img-alternate .txt-side {\r\n  width: 100%;\r\n}\r\n#content.tab.contact section.with-side-image.img-alternate .txt-side > * {\r\n  max-width: max-content;\r\n  margin: 0 auto;\r\n}\r\n\r\n#content.tab.contact div.days-and-hours {\r\n  display: grid;\r\n  justify-content: space-between;\r\n  grid-template-columns: max-content max-content;\r\n}\r\n\r\n#content.tab.contact .txt-side .days {\r\n  color: var(--section-col-h4);\r\n  font-variant: small-caps;\r\n  text-transform: lowercase;\r\n  font-weight: bold;\r\n}\r\n\r\n#content.tab.contact .txt-side .hours {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0px var(--contact-hours-horizontal-gap);\r\n}\r\n\r\n#content.tab.contact .txt-side .hour {\r\n  width: max-content;\r\n}\r\n\r\n@media only screen and (min-width: 1024px) {\r\n  #content.tab.contact .txt-side .hours {\r\n    flex-direction: row;\r\n  }\r\n}\r\n\r\n.contact-info {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1em;\r\n}\r\n\r\n.contact-info > .contact-list > * {\r\n  display: grid;\r\n  grid-template-columns: max-content 1fr;\r\n  text-wrap: balance;\r\n  gap: 0.5em;\r\n}\r\n\r\n/* Purposely exclude .address from here to better centering .contact-info */\r\n.contact-info .phone,\r\n.contact-info .email {\r\n  width: max-content;\r\n}\r\n\r\n.contact-info > .contact-social {\r\n  display: flex !important;\r\n  flex-direction: row !important;\r\n  justify-content: center;\r\n  gap: 1em !important;\r\n  color: var(--col-txt);\r\n}\r\n\r\n@media not all and (hover: none) {\r\n  .contact-info > .contact-social a:hover {\r\n    color: var(--col-accent);\r\n    cursor: pointer;\r\n  }\r\n}\r\n\r\nsvg.svg-inline--fa {\r\n  vertical-align: top;\r\n  color: var(--section-col-h3);\r\n}\r\n\r\n/* See https://blog.duda.co/responsive-google-maps-for-your-website */\r\n#content.tab section .txt-side > .location-map {\r\n  overflow: hidden;\r\n  border-radius: var(--map-radius);\r\n  display: initial !important;\r\n  padding-bottom: 56.25%;\r\n  position: relative;\r\n  height: 0;\r\n  flex: 1;\r\n  min-width: 100%;\r\n}\r\n\r\n#content.tab section .txt-side > .location-map iframe {\r\n  display: initial !important;\r\n  left: 0;\r\n  top: 0;\r\n  height: 100%;\r\n  width: 100%;\r\n  position: absolute;\r\n}\r\n\r\n/* BOOK NOW tab */\r\n\r\n#content.tab.book-now h2 {\r\n  display: none;\r\n}\r\n\r\n#content.tab.book-now h3 {\r\n  color: var(--col-h3-book-now);\r\n  text-align: center;\r\n}\r\n\r\n#content.tab.book-now section .section-container {\r\n  backdrop-filter: blur(2px) brightness(70%);\r\n  max-width: 100%;\r\n}\r\n\r\n#content.tab.book-now button {\r\n  grid-area: button;\r\n  justify-self: center;\r\n}\r\n\r\n#content.tab.book-now form {\r\n  display: grid;\r\n  grid-template-areas:\r\n    \"name\"\r\n    \"guests\"\r\n    \"date\"\r\n    \"hour\"\r\n    \"email\"\r\n    \"phone\"\r\n    \"note\"\r\n    \".\"\r\n    \"button\";\r\n  grid-template-columns: 1fr;\r\n  grid-template-columns: auto;\r\n  gap: var(--book-now-input-div-gap);\r\n  max-width: var(--book-now-max-width);\r\n  width: 100%;\r\n  margin: 0 auto;\r\n}\r\n\r\n@media only screen and (min-width: 768px), (orientation: landscape) {\r\n  #content.tab.book-now form {\r\n    grid-template-areas:\r\n      \"name name name name\"\r\n      \"date date hour guests\"\r\n      \"phone phone email email\"\r\n      \"note note note note\"\r\n      \". . . .\"\r\n      \". button button .\";\r\n    grid-template-columns: 1fr 1fr 1fr 1fr;\r\n  }\r\n}\r\n\r\n#content.tab.book-now form .name-input-div {\r\n  grid-area: name;\r\n}\r\n#content.tab.book-now form .guests-input-div {\r\n  grid-area: guests;\r\n}\r\n#content.tab.book-now form .date-input-div {\r\n  grid-area: date;\r\n}\r\n#content.tab.book-now form .hour-input-div {\r\n  grid-area: hour;\r\n}\r\n#content.tab.book-now form .phone-input-div {\r\n  grid-area: phone;\r\n}\r\n#content.tab.book-now form .email-input-div {\r\n  grid-area: email;\r\n}\r\n#content.tab.book-now form .note-input-div {\r\n  grid-area: note;\r\n}\r\n\r\n#content.tab.book-now form > div {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n#content.tab.book-now form input,\r\n#content.tab.book-now form textarea {\r\n  border-radius: var(--book-now-input-radius);\r\n  border: none;\r\n  outline: none;\r\n}\r\n\r\n#content.tab.book-now form label,\r\n#content.tab.book-now form input,\r\n#content.tab.book-now form textarea {\r\n  padding: var(--book-now-input-padding);\r\n  font-size: var(--book-now-font-size);\r\n}\r\n\r\n#content.tab.book-now form label {\r\n  padding-top: 0;\r\n  color: var(--col-txt-alt);\r\n}\r\n\r\n#content.tab.book-now form label:has(+ input:optional)::after,\r\n#content.tab.book-now form label:has(+ textarea:optional)::after {\r\n  content: \" (optional)\";\r\n  font-style: italic;\r\n  color: var(--col-light-grey);\r\n}\r\n\r\n/* FOOTER */\r\n:root {\r\n  --footer-days-and-hours-padding: 1rem;\r\n}\r\n\r\nfooter.main-footer {\r\n  width: 100%;\r\n  max-width: var(--max-width);\r\n  margin: 0 auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: var(--footer-padding);\r\n  gap: var(--footer-padding);\r\n}\r\n\r\nfooter.main-footer .footer-content {\r\n  display: grid;\r\n  grid-template-areas:\r\n    \"logo\"\r\n    \"info\"\r\n    \"hours\";\r\n  grid-template-columns: min-content;\r\n  justify-content: center;\r\n  justify-items: center;\r\n  gap: var(--footer-gap);\r\n}\r\n\r\nfooter.main-footer .logo-and-name {\r\n  grid-area: logo;\r\n  flex-direction: column;\r\n}\r\nfooter.main-footer .contact-info {\r\n  grid-area: info;\r\n  align-self: center;\r\n}\r\n\r\nfooter.main-footer .days-and-hours {\r\n  grid-area: hours;\r\n  display: grid;\r\n  grid-template-columns: max-content;\r\n  border-top: 1px solid var(--col-txt);\r\n  justify-content: center;\r\n  justify-items: center;\r\n  padding: var(--footer-days-and-hours-padding);\r\n  padding-bottom: 0;\r\n}\r\nfooter.main-footer .days-and-hours .days {\r\n  font-weight: bold;\r\n}\r\nfooter.main-footer .days-and-hours .days:not(:first-child) {\r\n  margin-top: var(--footer-days-and-hours-padding);\r\n}\r\nfooter.main-footer .days-and-hours .hours {\r\n  display: flex;\r\n}\r\n\r\nfooter.main-footer .days-and-hours .hour:not(:last-child):after {\r\n  content: \",\\00a0\";\r\n}\r\n\r\nfooter.main-footer .img-credit {\r\n  grid-area: \"img-credit\";\r\n  text-align: justify;\r\n  text-justify: inter-word;\r\n  text-wrap: pretty;\r\n}\r\n\r\nfooter.main-footer .img-credit a {\r\n  font-weight: bold;\r\n}\r\n\r\n@media not all and (hover: none) {\r\n  footer.main-footer .img-credit a:hover {\r\n    text-shadow: 2px 2px 2px var(--col-accent);\r\n    cursor: pointer;\r\n  }\r\n}\r\n\r\n@media only screen and (min-width: 768px), (orientation: landscape) {\r\n  footer.main-footer .footer-content {\r\n    grid-template-areas:\r\n      \"logo info\"\r\n      \"hours hours\";\r\n    grid-template-columns: max-content max-content;\r\n  }\r\n\r\n  footer.main-footer .days-and-hours {\r\n    grid-template-columns: max-content max-content;\r\n    justify-items: start;\r\n    gap: 0 var(--footer-days-and-hours-padding);\r\n  }\r\n\r\n  footer.main-footer .days-and-hours .days:not(:first-child) {\r\n    margin-top: 0;\r\n  }\r\n}\r\n\r\n@media only screen and (min-width: 1024px) {\r\n  footer.main-footer .footer-content {\r\n    grid-template-areas: \"logo info hours\";\r\n    grid-template-columns: max-content max-content max-content;\r\n  }\r\n\r\n  footer.main-footer .days-and-hours {\r\n    align-self: center;\r\n    border: none;\r\n    border-left: 1px solid var(--col-txt);\r\n    padding: var(--footer-days-and-hours-padding);\r\n    padding-right: 0;\r\n  }\r\n\r\n  footer.main-footer .days-and-hours .days:not(:first-child) {\r\n    margin-top: 0;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
